// extracted by mini-css-extract-plugin
export default {"box":"Checkbox_box__KRa4a","container":"Checkbox_container__2EiKS","checkmark":"Checkbox_checkmark__y4Tsq"};